msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: it\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-10-14 15:38\n"
"Last-Translator: \n"
"Language-Team: Italian\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: it\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:135
msgid "Locked"
msgstr "Privato"

#: src/components/account-block.jsx:141
msgid "Posts: {0}"
msgstr "Post: {0}"

#: src/components/account-block.jsx:146
msgid "Last posted: {0}"
msgstr "Ultimo post: {0}"

#: src/components/account-block.jsx:161
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "Automatizzato"

#: src/components/account-block.jsx:168
#: src/components/account-info.jsx:639
#: src/components/status.jsx:480
#: src/pages/catchup.jsx:1471
msgid "Group"
msgstr "Gruppo"

#: src/components/account-block.jsx:178
msgid "Mutual"
msgstr "Reciproci"

#: src/components/account-block.jsx:182
#: src/components/account-info.jsx:1680
msgid "Requested"
msgstr "Richiesta inviata"

#: src/components/account-block.jsx:186
#: src/components/account-info.jsx:1671
msgid "Following"
msgstr "Seguiti"

#: src/components/account-block.jsx:190
#: src/components/account-info.jsx:1062
msgid "Follows you"
msgstr "Ti segue"

#: src/components/account-block.jsx:198
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# seguace} other {# seguaci}}"

#: src/components/account-block.jsx:207
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "Verificato"

#: src/components/account-block.jsx:222
#: src/components/account-info.jsx:780
msgid "Joined <0>{0}</0>"
msgstr "Iscritto <0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Per sempre"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "Impossibile caricare account."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "Vai alla pagina dell'account"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "Seguaci"

#. js-lingui-explicit-id
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:759
msgid "following.stats"
msgstr ""

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:776
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:237
#: src/pages/search.jsx:384
msgid "Posts"
msgstr "Post"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1118
#: src/components/compose.jsx:2488
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1703
#: src/components/status.jsx:1720
#: src/components/status.jsx:1844
#: src/components/status.jsx:2442
#: src/components/status.jsx:2445
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1181
#: src/pages/trending.jsx:471
msgid "More"
msgstr "Altro"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> ha comunicato che il suo nuovo account è ora:"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1276
msgid "Handle copied"
msgstr "Nome utente copiato"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1279
msgid "Unable to copy handle"
msgstr "Impossibile copiare nome utente"

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1285
msgid "Copy handle"
msgstr "Copia nome utente"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "Vai alla pagina del profilo originale"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "Visualizza immagine di profilo"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "Visualizza immagine di copertina"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "In memoriam"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:750
msgid "This user has chosen to not make this information available."
msgstr "L'utente ha deciso di non condividere questa informazione."

#: src/components/account-info.jsx:805
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} post originali, {1} risposte, {2} reblog"

#: src/components/account-info.jsx:821
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural,one {{1, plural,one {Ultimo post nell'ultimo giorno}other {Ultimo post negli ultimi {2} giorni}}} other {{3, plural,one {Ultimi {4} post nell'ultimo giorno} other {Ultimi {5} post negli ultimi {6} giorni}}}}"

#: src/components/account-info.jsx:834
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Ultimo post nell'ultimo anno(i)} other {Ultimi {1} post nell'ultimo anno(i)}}"

#: src/components/account-info.jsx:858
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Originale"

#: src/components/account-info.jsx:862
#: src/components/status.jsx:2233
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1445
#: src/pages/catchup.jsx:2056
#: src/pages/status.jsx:904
#: src/pages/status.jsx:1506
msgid "Replies"
msgstr "Risposte"

#: src/components/account-info.jsx:866
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1447
#: src/pages/catchup.jsx:2068
#: src/pages/settings.jsx:1110
msgid "Boosts"
msgstr "Reblog"

#: src/components/account-info.jsx:872
msgid "Post stats unavailable."
msgstr "Statistiche post non disponibili."

#: src/components/account-info.jsx:903
msgid "View post stats"
msgstr "Visualizza statistiche post"

#: src/components/account-info.jsx:1066
msgid "Last post: <0>{0}</0>"
msgstr "Ultimo post: <0>{0}</0>"

#: src/components/account-info.jsx:1080
msgid "Muted"
msgstr "Silenziato"

#: src/components/account-info.jsx:1085
msgid "Blocked"
msgstr "Bloccato"

#: src/components/account-info.jsx:1094
msgid "Private note"
msgstr "Nota privata"

#: src/components/account-info.jsx:1151
msgid "Mention <0>@{username}</0>"
msgstr "Menziona  <0>@{username}</0>"

#: src/components/account-info.jsx:1163
msgid "Translate bio"
msgstr "Traduci bio"

#: src/components/account-info.jsx:1174
msgid "Edit private note"
msgstr "Modifica nota privata"

#: src/components/account-info.jsx:1174
msgid "Add private note"
msgstr "Aggiungi nota privata"

#: src/components/account-info.jsx:1194
msgid "Notifications enabled for @{username}'s posts."
msgstr "Notifiche attivate per i post di @{username}."

#: src/components/account-info.jsx:1195
msgid "Notifications disabled for @{username}'s posts."
msgstr "Notifiche disattivate per i post di @{username}."

#: src/components/account-info.jsx:1207
msgid "Disable notifications"
msgstr "Disattiva notifiche"

#: src/components/account-info.jsx:1208
msgid "Enable notifications"
msgstr "Attiva notifiche"

#: src/components/account-info.jsx:1225
msgid "Boosts from @{username} enabled."
msgstr "Reblog da @{username} abilitati."

#: src/components/account-info.jsx:1226
msgid "Boosts from @{username} disabled."
msgstr "Reblog da @{username} disattivati."

#: src/components/account-info.jsx:1237
msgid "Disable boosts"
msgstr "Disattiva reblog"

#: src/components/account-info.jsx:1237
msgid "Enable boosts"
msgstr "Abilita reblog"

#: src/components/account-info.jsx:1253
#: src/components/account-info.jsx:1263
#: src/components/account-info.jsx:1864
msgid "Add/Remove from Lists"
msgstr "Aggiungi/rimuovi da liste"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1143
msgid "Link copied"
msgstr "Link copiato"

#: src/components/account-info.jsx:1305
#: src/components/status.jsx:1146
msgid "Unable to copy link"
msgstr "Impossibile copiare link"

#: src/components/account-info.jsx:1311
#: src/components/shortcuts-settings.jsx:1059
#: src/components/status.jsx:1152
#: src/components/status.jsx:3219
msgid "Copy"
msgstr "Copia"

#: src/components/account-info.jsx:1326
#: src/components/shortcuts-settings.jsx:1077
#: src/components/status.jsx:1168
msgid "Sharing doesn't seem to work."
msgstr "La condivisione non sembra funzionare."

#: src/components/account-info.jsx:1332
#: src/components/status.jsx:1174
msgid "Share…"
msgstr "Condividi…"

#: src/components/account-info.jsx:1352
msgid "Unmuted @{username}"
msgstr "@{username} riattivato"

#: src/components/account-info.jsx:1364
msgid "Unmute <0>@{username}</0>"
msgstr "Riattiva <0>@{username}</0>"

#: src/components/account-info.jsx:1380
msgid "Mute <0>@{username}</0>…"
msgstr "Silenzia <0>@{username}</0>…"

#: src/components/account-info.jsx:1412
msgid "Muted @{username} for {0}"
msgstr "Hai silenziato @{username} per {0}"

#: src/components/account-info.jsx:1424
msgid "Unable to mute @{username}"
msgstr "Impossibile silenziare @{username}"

#: src/components/account-info.jsx:1445
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Rimuovere <0>@{username}</0> dai seguaci?"

#: src/components/account-info.jsx:1465
msgid "@{username} removed from followers"
msgstr "@{username} rimosso dai seguaci"

#: src/components/account-info.jsx:1477
msgid "Remove follower…"
msgstr "Rimuovi seguace…"

#: src/components/account-info.jsx:1488
msgid "Block <0>@{username}</0>?"
msgstr "Bloccare <0>@{username}</0>?"

#: src/components/account-info.jsx:1512
msgid "Unblocked @{username}"
msgstr "@{username} sbloccato"

#: src/components/account-info.jsx:1520
msgid "Blocked @{username}"
msgstr "@{username} bloccato"

#: src/components/account-info.jsx:1528
msgid "Unable to unblock @{username}"
msgstr "Impossibile sbloccare @{username}"

#: src/components/account-info.jsx:1530
msgid "Unable to block @{username}"
msgstr "Impossibile bloccare @{username}"

#: src/components/account-info.jsx:1540
msgid "Unblock <0>@{username}</0>"
msgstr "Sblocca <0>@{username}</0>"

#: src/components/account-info.jsx:1549
msgid "Block <0>@{username}</0>…"
msgstr "Blocca <0>@{username}</0>…"

#: src/components/account-info.jsx:1566
msgid "Report <0>@{username}</0>…"
msgstr "Segnala <0>@{username}</0>…"

#: src/components/account-info.jsx:1586
#: src/components/account-info.jsx:2097
msgid "Edit profile"
msgstr "Modifica profilo"

#: src/components/account-info.jsx:1622
msgid "Withdraw follow request?"
msgstr "Ritirare richiesta di seguire?"

#: src/components/account-info.jsx:1623
msgid "Unfollow @{0}?"
msgstr "Smettere di seguire @{0}?"

#: src/components/account-info.jsx:1674
msgid "Unfollow…"
msgstr "Smetti di seguire…"

#: src/components/account-info.jsx:1683
msgid "Withdraw…"
msgstr "Ritira…"

#: src/components/account-info.jsx:1690
#: src/components/account-info.jsx:1694
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Segui"

#: src/components/account-info.jsx:1805
#: src/components/account-info.jsx:1859
#: src/components/account-info.jsx:1992
#: src/components/account-info.jsx:2092
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:818
#: src/components/compose.jsx:2444
#: src/components/compose.jsx:2917
#: src/components/compose.jsx:3125
#: src/components/compose.jsx:3355
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:230
#: src/components/shortcuts-settings.jsx:583
#: src/components/shortcuts-settings.jsx:783
#: src/components/status.jsx:2944
#: src/components/status.jsx:3183
#: src/components/status.jsx:3681
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1581
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:868
#: src/pages/notifications.jsx:1082
#: src/pages/settings.jsx:76
#: src/pages/status.jsx:1268
msgid "Close"
msgstr "Chiudi"

#: src/components/account-info.jsx:1810
msgid "Translated Bio"
msgstr "Bio tradotta"

#: src/components/account-info.jsx:1904
msgid "Unable to remove from list."
msgstr "Impossibile rimuovere da lista."

#: src/components/account-info.jsx:1905
msgid "Unable to add to list."
msgstr "Impossibile aggiungere alla lista."

#: src/components/account-info.jsx:1924
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "Impossibile caricare lista."

#: src/components/account-info.jsx:1928
msgid "No lists."
msgstr "Nessuna lista."

#: src/components/account-info.jsx:1939
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Nuova lista"

#: src/components/account-info.jsx:1997
msgid "Private note about <0>@{0}</0>"
msgstr "Nota privata su <0>@{0}</0>"

#: src/components/account-info.jsx:2027
msgid "Unable to update private note."
msgstr "Impossibile aggiornare nota privata."

#: src/components/account-info.jsx:2050
#: src/components/account-info.jsx:2220
msgid "Cancel"
msgstr "Annulla"

#: src/components/account-info.jsx:2055
msgid "Save & close"
msgstr "Salva e chiudi"

#: src/components/account-info.jsx:2148
msgid "Unable to update profile."
msgstr "Impossibile aggiornare profilo."

#: src/components/account-info.jsx:2155
#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "Nome"

#: src/components/account-info.jsx:2168
msgid "Bio"
msgstr "Bio"

#: src/components/account-info.jsx:2181
msgid "Extra fields"
msgstr "Campi extra"

#: src/components/account-info.jsx:2187
msgid "Label"
msgstr "Etichetta"

#: src/components/account-info.jsx:2190
msgid "Content"
msgstr "Contenuto"

#: src/components/account-info.jsx:2223
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:715
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:934
msgid "Save"
msgstr "Salva"

#: src/components/account-info.jsx:2276
msgid "username"
msgstr "nome utente"

#: src/components/account-info.jsx:2280
msgid "server domain name"
msgstr "nome dominio del server"

#: src/components/background-service.jsx:149
msgid "Cloak mode disabled"
msgstr "Modalità mantello disattivata"

#: src/components/background-service.jsx:149
msgid "Cloak mode enabled"
msgstr "Modalità mantello attivata"

#: src/components/columns.jsx:19
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:139
#: src/components/timeline.jsx:437
#: src/pages/catchup.jsx:876
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:53
#: src/pages/notifications.jsx:520
msgid "Home"
msgstr "Home"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Componi"

#: src/components/compose.jsx:394
msgid "You have unsaved changes. Discard this post?"
msgstr "Ci sono modifiche non salvate. Scartare il post?"

#: src/components/compose.jsx:622
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr ""

#: src/components/compose.jsx:632
#: src/components/compose.jsx:650
#: src/components/compose.jsx:1361
#: src/components/compose.jsx:1623
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Puoi allegare fino a 1 documento.} other {Puoi allegare fino a # documenti.}}"

#: src/components/compose.jsx:799
msgid "Pop out"
msgstr "Scollega"

#: src/components/compose.jsx:806
msgid "Minimize"
msgstr "Contrai"

#: src/components/compose.jsx:842
msgid "Looks like you closed the parent window."
msgstr "Sembra tu abbia chiuso la finestra genitore."

#: src/components/compose.jsx:849
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Sembra tu abbia già un campo di composizione aperto nella finestra genitore e sia in fase di pubblicazione. Attendi il completamento e riprova."

#: src/components/compose.jsx:854
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Sembra che tu abbia già un campo di composizione aperto nella finestra principale. Far apparire questa finestra eliminerà le modifiche effetuate nella finestra principale. Vuoi proseguire?"

#: src/components/compose.jsx:896
msgid "Pop in"
msgstr "Collega"

#: src/components/compose.jsx:906
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "In risposta al post di @{0} (<0>{1}</0>)"

#: src/components/compose.jsx:916
msgid "Replying to @{0}’s post"
msgstr "In risposta al post di @{0}"

#: src/components/compose.jsx:929
msgid "Editing source post"
msgstr "Modificando post originale"

#: src/components/compose.jsx:976
msgid "Poll must have at least 2 options"
msgstr "Il sondaggio deve avere almeno 2 opzioni"

#: src/components/compose.jsx:980
msgid "Some poll choices are empty"
msgstr "Alcune scelte del sondaggio sono vuote"

#: src/components/compose.jsx:993
msgid "Some media have no descriptions. Continue?"
msgstr "Alcuni media sono senza descrizione. Continuare?"

#: src/components/compose.jsx:1045
msgid "Attachment #{i} failed"
msgstr "Allegato #{i} fallito"

#: src/components/compose.jsx:1139
#: src/components/status.jsx:2029
#: src/components/timeline.jsx:984
msgid "Content warning"
msgstr "Avviso contenuto"

#: src/components/compose.jsx:1155
msgid "Content warning or sensitive media"
msgstr "Avviso contenuto o media sensibili"

#: src/components/compose.jsx:1191
#: src/components/status.jsx:93
#: src/pages/settings.jsx:304
msgid "Public"
msgstr "Pubblico"

#: src/components/compose.jsx:1196
#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:165
#: src/components/status.jsx:94
msgid "Local"
msgstr "Locale"

#: src/components/compose.jsx:1200
#: src/components/status.jsx:95
#: src/pages/settings.jsx:307
msgid "Unlisted"
msgstr "Non in lista"

#: src/components/compose.jsx:1203
#: src/components/status.jsx:96
#: src/pages/settings.jsx:310
msgid "Followers only"
msgstr "Solo seguaci"

#: src/components/compose.jsx:1206
#: src/components/status.jsx:97
#: src/components/status.jsx:1907
msgid "Private mention"
msgstr "Menzione privata"

#: src/components/compose.jsx:1215
msgid "Post your reply"
msgstr "Pubblica la tua risposta"

#: src/components/compose.jsx:1217
msgid "Edit your post"
msgstr "Modifica il tuo post"

#: src/components/compose.jsx:1218
msgid "What are you doing?"
msgstr "Che stai facendo?"

#: src/components/compose.jsx:1296
msgid "Mark media as sensitive"
msgstr "Contrassegna media come sensibili"

#: src/components/compose.jsx:1397
msgid "Add poll"
msgstr "Aggiungi sondaggio"

#: src/components/compose.jsx:1419
msgid "Add custom emoji"
msgstr "Aggiungo emoji personalizzata"

#: src/components/compose.jsx:1504
#: src/components/keyboard-shortcuts-help.jsx:143
#: src/components/status.jsx:895
#: src/components/status.jsx:1683
#: src/components/status.jsx:1684
#: src/components/status.jsx:2338
msgid "Reply"
msgstr "Rispondi"

#: src/components/compose.jsx:1506
msgid "Update"
msgstr "Aggiorna"

#: src/components/compose.jsx:1507
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Pubblica"

#: src/components/compose.jsx:1635
msgid "Downloading GIF…"
msgstr "Scarico GIF…"

#: src/components/compose.jsx:1663
msgid "Failed to download GIF"
msgstr "Download GIF fallito"

#: src/components/compose.jsx:1775
#: src/components/compose.jsx:1852
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "Altro…"

#: src/components/compose.jsx:2257
msgid "Uploaded"
msgstr "Caricato"

#: src/components/compose.jsx:2270
msgid "Image description"
msgstr "Descrizione immagine"

#: src/components/compose.jsx:2271
msgid "Video description"
msgstr "Descrizione video"

#: src/components/compose.jsx:2272
msgid "Audio description"
msgstr "Descrizione audio"

#: src/components/compose.jsx:2308
#: src/components/compose.jsx:2328
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "File troppo pesante. Il caricamento potrebbe riscontrare degli errori. Prova a ridurre la dimensione del file da {0} a {1} o meno."

#: src/components/compose.jsx:2320
#: src/components/compose.jsx:2340
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Dimensioni eccessive. Il caricamento potrebbe riscontrare degli errori. Prova a ridurre le dimensioni da {0}×{1}px a {2}×{3}px."

#: src/components/compose.jsx:2348
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Frequenza fotogrammi troppo alta. Il caricamento potrebbe riscontrare degli errori."

#: src/components/compose.jsx:2408
#: src/components/compose.jsx:2658
#: src/components/shortcuts-settings.jsx:726
#: src/pages/catchup.jsx:1074
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Rimuovi"

#: src/components/compose.jsx:2425
#: src/compose.jsx:83
msgid "Error"
msgstr "Errore"

#: src/components/compose.jsx:2450
msgid "Edit image description"
msgstr "Modifica descrizione immagine"

#: src/components/compose.jsx:2451
msgid "Edit video description"
msgstr "Modifica descrizione video"

#: src/components/compose.jsx:2452
msgid "Edit audio description"
msgstr "Modifica descrizione audio"

#: src/components/compose.jsx:2497
#: src/components/compose.jsx:2546
msgid "Generating description. Please wait…"
msgstr "Genero descrizione. Attendere…"

#: src/components/compose.jsx:2517
msgid "Failed to generate description: {0}"
msgstr "Generazione descrizione fallita: {0}"

#: src/components/compose.jsx:2518
msgid "Failed to generate description"
msgstr "Generazione descrizione fallita"

#: src/components/compose.jsx:2530
#: src/components/compose.jsx:2536
#: src/components/compose.jsx:2582
msgid "Generate description…"
msgstr "Genera descrizione…"

#: src/components/compose.jsx:2569
msgid "Failed to generate description{0}"
msgstr "Generazione descrizione fallita: {0}"

#: src/components/compose.jsx:2584
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— sperimentale</0>"

#: src/components/compose.jsx:2603
msgid "Done"
msgstr "Fine"

#: src/components/compose.jsx:2639
msgid "Choice {0}"
msgstr "Opzione {0}"

#: src/components/compose.jsx:2686
msgid "Multiple choices"
msgstr "Scelta multipla"

#: src/components/compose.jsx:2689
msgid "Duration"
msgstr "Durata"

#: src/components/compose.jsx:2720
msgid "Remove poll"
msgstr "Rimuovi sondaggio"

#: src/components/compose.jsx:2934
msgid "Search accounts"
msgstr "Cerca account"

#: src/components/compose.jsx:2975
#: src/components/shortcuts-settings.jsx:715
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Aggiungi"

#: src/components/compose.jsx:2988
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "Errore caricamento account"

#: src/components/compose.jsx:3131
msgid "Custom emojis"
msgstr "Emoji personalizzate"

#: src/components/compose.jsx:3151
msgid "Search emoji"
msgstr "Cerca emoji"

#: src/components/compose.jsx:3182
msgid "Error loading custom emojis"
msgstr "Errore caricamento emoji personalizzate"

#: src/components/compose.jsx:3193
msgid "Recently used"
msgstr "Usate di recente"

#: src/components/compose.jsx:3194
msgid "Others"
msgstr "Altri"

#: src/components/compose.jsx:3232
msgid "{0} more…"
msgstr "{0} altri…"

#: src/components/compose.jsx:3370
msgid "Search GIFs"
msgstr "Cerca GIF"

#: src/components/compose.jsx:3385
msgid "Powered by GIPHY"
msgstr "Fornito da GIPHY"

#: src/components/compose.jsx:3393
msgid "Type to search GIFs"
msgstr "Scrivi per cercare GIF"

#: src/components/compose.jsx:3491
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:889
msgid "Previous"
msgstr "Indietro"

#: src/components/compose.jsx:3509
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:906
msgid "Next"
msgstr "Avanti"

#: src/components/compose.jsx:3526
msgid "Error loading GIFs"
msgstr "Errore caricamento GIF"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:691
msgid "Unsent drafts"
msgstr "Bozze in sospeso"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Sembra tu abbia delle bozze non inviate. Riprendiamo da lì."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "Eliminare questa bozza?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Errore nell'eliminazione della bozza! Riprova."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1318
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Elimina…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "Errore nel recupero dello stato rispondi-a!"

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "Eliminare tutte le bozze?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "Errore nell'eliminazione delle bozze! Riprova."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Elimina tutte…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "Nessuna bozza."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1928
msgid "Poll"
msgstr "Sondaggio"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Media"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "Apri in nuova finestra"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:918
msgid "Accept"
msgstr "Accetta"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Rifiuta"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1201
msgid "Accepted"
msgstr "Accettata"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Rifiutata"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Nulla da mostrare"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:438
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:227
#: src/pages/search.jsx:260
msgid "Accounts"
msgstr "Account"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:519
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:848
#: src/pages/search.jsx:454
#: src/pages/status.jsx:1301
msgid "Show more…"
msgstr "Mostra altro…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:524
#: src/pages/search.jsx:459
msgid "The end."
msgstr "Fine."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1619
msgid "Keyboard shortcuts"
msgstr "Abbreviazioni da tastiera"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Aiuto abbreviazioni da tastiera"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1644
msgid "Next post"
msgstr "Post successivo"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1652
msgid "Previous post"
msgstr "Post precedente"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Salta il carosello e vai al post successivo"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Maiusc</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Salta il carosello e vai al post precedente"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Maiusc</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Carica nuovi post"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1676
msgid "Open post details"
msgstr "Apri dettagli post"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Invio</0> or <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Espandi avviso contenuti o<0/>o espandi/comprimi discussione"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Chiudi post o schermata"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> o <1>Backspace</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Seleziona colonna in modalità multi-colonna"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> a <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Compose new post"
msgstr "Componi nuovo post"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Compose new post (new window)"
msgstr "Componi nuovo post (nuova finestra)"

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Maiusc</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Send post"
msgstr "Invia post"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Invio</1> o <2>⌘</2> + <3>Invio</3>"

#: src/components/keyboard-shortcuts-help.jsx:139
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:179
#: src/pages/search.jsx:39
#: src/pages/search.jsx:209
msgid "Search"
msgstr "Cerca"

#: src/components/keyboard-shortcuts-help.jsx:147
msgid "Reply (new window)"
msgstr "Rispondi (nuova finestra)"

#: src/components/keyboard-shortcuts-help.jsx:150
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Maiusc</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Like (favourite)"
msgstr "Mi piace (apprezzamento)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> o <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:903
#: src/components/status.jsx:2364
#: src/components/status.jsx:2396
#: src/components/status.jsx:2397
msgid "Boost"
msgstr "Reblog"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Maiusc</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:988
#: src/components/status.jsx:2421
#: src/components/status.jsx:2422
msgid "Bookmark"
msgstr "Aggiungi ai segnalibri"

#: src/components/keyboard-shortcuts-help.jsx:176
msgid "Toggle Cloak mode"
msgstr "Imposta modalità mantello"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Maiusc</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "Modifica lista"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "Impossibile modificare lista."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "Impossibile creare lista."

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "Mostra risposte ai membri della lista"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "Mostra risposte alle persone che seguo"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "Non mostrare risposte"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr "Nascondi i post di questa lista da Home/Seguiti"

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Crea"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "Eliminare questa lista?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "Impossibile eliminare lista."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Descrizione media"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:1032
#: src/components/status.jsx:1059
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Traduci"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:1046
#: src/components/status.jsx:1073
msgid "Speak"
msgstr "Leggi"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "Apri media originale in una nuova finestra"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "Apri media originale"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "Cerco di descrivere l'immagine. Attendere…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "Descrizione immagine fallita"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "Descrivi immagine…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "Visualizza post"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Media sensibili"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Filtrato: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3511
#: src/components/status.jsx:3607
#: src/components/status.jsx:3685
#: src/components/timeline.jsx:973
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1876
msgid "Filtered"
msgstr "Filtrato"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Post pubblicato. Dai un'occhiata."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Risposta pubblicata. Dai un'occhiata."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Post aggiornato. Dai un'occhiata."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "Menu"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "Ricaricare pagina ora per aggiornare?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "Nuovo aggiornamento disponibile…"

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:140
#: src/pages/following.jsx:22
#: src/pages/following.jsx:141
msgid "following.title"
msgstr ""

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:871
msgid "Catch-up"
msgstr "Recupera"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:146
#: src/pages/home.jsx:224
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1102
#: src/pages/trending.jsx:381
msgid "Mentions"
msgstr "Menzioni"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:152
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:84
#: src/pages/home.jsx:184
#: src/pages/notifications.jsx:112
#: src/pages/notifications.jsx:524
msgid "Notifications"
msgstr "Notifiche"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "Nuovo"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "Profilo"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:158
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Liste"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:209
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Tutte le liste"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:195
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Segnalibri"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:201
#: src/pages/catchup.jsx:1446
#: src/pages/catchup.jsx:2062
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1106
msgid "Likes"
msgstr "Mi piace"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Hashtag seguiti"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "FIltri"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "Utenti silenziati"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "Utenti silenziati…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "Utenti bloccati"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "Utenti bloccati…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "Account…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:189
#: src/pages/status.jsx:804
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Accedi"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:172
#: src/pages/trending.jsx:441
msgid "Trending"
msgstr "Tendenze"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:165
msgid "Federated"
msgstr "Federata"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "Scorciatoie / Colonne…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "Impostazioni…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Notifica"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Questa notifica viene da un altro account."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Visualizza tutte le notifiche"

#: src/components/notification.jsx:70
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} ha reagito al tuo post con {emojiObject}"

#: src/components/notification.jsx:77
msgid "{account} published a post."
msgstr "{account} ha pubblicato un post."

#: src/components/notification.jsx:85
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural,=1 {{postsCount, plural,=1 {{postType, select, reply {{account} ha rebloggato la tua risposta.} other {{account} ha rebloggato il tuo post.}}} other {{account} ha rebloggato {postsCount} dei tuoi post.}}}other {{postType, select, reply {<0><1>{0}</1> persone</0> hanno rebloggato la tua risposta.}other {<2><3>{1}</3> persone</2> hanno rebloggato il tuo post.}}}}"

#: src/components/notification.jsx:128
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, =1 {{account} ti ha iniziato a seguire.} other {<0><1>{0}</1> persone</0> ti hanno iniziato a seguire.}}"

#: src/components/notification.jsx:142
msgid "{account} requested to follow you."
msgstr "{account} ha richiesto di seguirti."

#: src/components/notification.jsx:151
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} ha messo Mi piace alla tua risposta.} other {{account} ha messo Mi piace al tuo post.}}} other {{account} ha messo {postsCount} Mi piace ai tuoi post.}}} other {{postType, select, reply {<0><1>{0}</1> persone</0> hanno messo Mi piace alla tua risposta.} other {<2><3>{1}</3> persone</2> hanno messo mi piace al tuo post.}}}}"

#: src/components/notification.jsx:193
msgid "A poll you have voted in or created has ended."
msgstr "Un sondaggio in cui hai votato o che hai creato è terminato."

#: src/components/notification.jsx:194
msgid "A poll you have created has ended."
msgstr "Un sondaggio che hai creato è terminato."

#: src/components/notification.jsx:195
msgid "A poll you have voted in has ended."
msgstr "Un sondaggio in cui hai votato è terminato."

#: src/components/notification.jsx:196
msgid "A post you interacted with has been edited."
msgstr "Un post con cui hai interagito è stato modificato."

#: src/components/notification.jsx:204
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} ha rebloggato e ha messo Mi piace alla tua risposta.} other {{account} ha rebloggato e messo Mi piace al tuo post.}}} other {{account} ha rebloggato e messo Mi piace a {postsCount} dei tuoi post.}}} other {{postType, select, reply {<0><1>{0}</1> persone</0> hanno rebloggato e messo Mi piace alla tua risposta.} other {<2><3>{1}</3> persone</2> hanno rebloggato e messo Mi piace al tuo post.}}}}"

#: src/components/notification.jsx:246
msgid "{account} signed up."
msgstr "{account} creato."

#: src/components/notification.jsx:248
msgid "{account} reported {targetAccount}"
msgstr "{account} ha segnalato {targetAccount}"

#: src/components/notification.jsx:253
msgid "Lost connections with <0>{name}</0>."
msgstr "Connessione con <0>{name}</0> persa."

#: src/components/notification.jsx:259
msgid "Moderation warning"
msgstr "Avviso di moderazione"

#: src/components/notification.jsx:269
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Un amministratore da <0>{from}</0> ha sospeso <1>{targetName}</1>, ciò significa che non puoi più ricevere aggiornamenti o interagire con loro."

#: src/components/notification.jsx:275
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "Un amministratore da <0>{from}</0> ha bloccato <1>{targetName}</1>. Seguaci interessati: {followersCount}, seguiti: {followingCount}."

#: src/components/notification.jsx:281
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Hai bloccato <0>{targetName}</0>. Seguaci rimossi: {followersCount}, seguiti: {followingCount}."

#: src/components/notification.jsx:289
msgid "Your account has received a moderation warning."
msgstr "Il tuo account ha ricevuto un avviso di moderazione."

#: src/components/notification.jsx:290
msgid "Your account has been disabled."
msgstr "Il tuo account è stato disabilitato."

#: src/components/notification.jsx:291
msgid "Some of your posts have been marked as sensitive."
msgstr "Alcuni dei tuoi post sono stati contrassegnati come sensibili."

#: src/components/notification.jsx:292
msgid "Some of your posts have been deleted."
msgstr "Alcuni dei tuoi post sono stati eliminati."

#: src/components/notification.jsx:293
msgid "Your posts will be marked as sensitive from now on."
msgstr "Da ora in poi i tuoi post verranno marcati come sensibili."

#: src/components/notification.jsx:294
msgid "Your account has been limited."
msgstr "Il tuo account è stato limitato."

#: src/components/notification.jsx:295
msgid "Your account has been suspended."
msgstr "Il tuo account è stato sospeso."

#: src/components/notification.jsx:369
msgid "[Unknown notification type: {type}]"
msgstr "[Tipo notifica sconosciuto: {type}]"

#: src/components/notification.jsx:434
#: src/components/status.jsx:1002
#: src/components/status.jsx:1012
msgid "Boosted/Liked by…"
msgstr "Rebloggato da/Piace a…"

#: src/components/notification.jsx:435
msgid "Liked by…"
msgstr "Piace a…"

#: src/components/notification.jsx:436
msgid "Boosted by…"
msgstr "Rebloggato da…"

#: src/components/notification.jsx:437
msgid "Followed by…"
msgstr "Seguito da…"

#: src/components/notification.jsx:508
#: src/components/notification.jsx:524
msgid "Learn more <0/>"
msgstr "Scopri di più <0/>"

#: src/components/notification.jsx:756
#: src/components/status.jsx:211
msgid "Read more →"
msgstr "Leggi di più →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "Votato"

#: src/components/poll.jsx:116
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr "{optionVotesCount, plural, one {# voto} other {# voti}}"

#: src/components/poll.jsx:136
#: src/components/poll.jsx:219
#: src/components/poll.jsx:223
msgid "Hide results"
msgstr "Nascondi risultati"

#: src/components/poll.jsx:185
msgid "Vote"
msgstr "Vota"

#: src/components/poll.jsx:205
#: src/components/poll.jsx:207
#: src/pages/status.jsx:1170
#: src/pages/status.jsx:1193
msgid "Refresh"
msgstr "Ricarica"

#: src/components/poll.jsx:219
#: src/components/poll.jsx:223
msgid "Show results"
msgstr "Mostra risultati"

#: src/components/poll.jsx:228
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> voto} other {<1>{1}</1> voti}}"

#: src/components/poll.jsx:245
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> votante} other {<1>{1}</1> votanti}}"

#: src/components/poll.jsx:265
msgid "Ended <0/>"
msgstr "Finito <0/>"

#: src/components/poll.jsx:269
msgid "Ended"
msgstr "Finito"

#: src/components/poll.jsx:272
msgid "Ending <0/>"
msgstr "Finendo <0/>"

#: src/components/poll.jsx:276
msgid "Ending"
msgstr "Finendo"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:57
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:62
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:67
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Spam"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Link malevoli, interazioni finte, o risposte ripetitive"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Illegale"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Viola la legge del tuo server o del paese del server"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Violazione delle regole del server"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Viola regole specifiche del server"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Violazione"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Altro"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "Il problema non rientra nelle altre categorie"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Segnala post"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Segnala @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Valutazione in sospeso"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Post segnalato"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Profilo segnalato"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "Impossibile segnalare post"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "Impossibile segnalare profilo"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Qual'è il problema con questo post?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Qual'è il problema con questo profilo?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Informazioni aggiuntive"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Inoltra a <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Invia segnalazione"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "Silenziato {username}"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "Impossibile silenziare {username}"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Invia segnalazione <0>+ silenzia profilo</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "{username} Bloccato"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "Impossibile bloccare {username}"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Invia segnalazione <0>+ blocca profilo</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query}<0>- account, hashtag e post</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr "Post con <0>{query}</0>"

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Post contenenti <0>#{0}</0>"

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "Cerca <0>{query}</0>"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "Account con <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Home / Seguiti"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Pubblico (Locale / Federata)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Account"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Hashtag"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "ID lista"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Solo locale"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:193
msgid "Instance"
msgstr "Istanza"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Opzionale, per es. mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Termine di ricerca"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Opzionale, tranne per la modalità multi-colonna"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "es. PixelArt (max 5, separati da spazi)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "Solo media"

#: src/components/shortcuts-settings.jsx:235
#: src/components/shortcuts.jsx:186
msgid "Shortcuts"
msgstr "Scorciatoie"

#: src/components/shortcuts-settings.jsx:243
msgid "beta"
msgstr "beta"

#: src/components/shortcuts-settings.jsx:249
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Specifica una lista di scorciatoie che apparirà come:"

#: src/components/shortcuts-settings.jsx:255
msgid "Floating button"
msgstr "Tasto fluttuante"

#: src/components/shortcuts-settings.jsx:260
msgid "Tab/Menu bar"
msgstr "Barra navigazione/menu"

#: src/components/shortcuts-settings.jsx:265
msgid "Multi-column"
msgstr "Multi-colonna"

#: src/components/shortcuts-settings.jsx:332
msgid "Not available in current view mode"
msgstr "Non disponibile nella modalità di visualizzazione attuale"

#: src/components/shortcuts-settings.jsx:351
msgid "Move up"
msgstr "Sposta su"

#: src/components/shortcuts-settings.jsx:367
msgid "Move down"
msgstr "Sposta giù"

#: src/components/shortcuts-settings.jsx:379
#: src/components/status.jsx:1280
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "Modifica"

#: src/components/shortcuts-settings.jsx:400
msgid "Add more than one shortcut/column to make this work."
msgstr "Aggiungi più di una scorciatoia/colonna per fare in modo che funzioni."

#: src/components/shortcuts-settings.jsx:411
msgid "No columns yet. Tap on the Add column button."
msgstr "Ancora nessuna colonna. Clicca il bottone Aggiungi colonna."

#: src/components/shortcuts-settings.jsx:412
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Ancora nessuna scorciatoia. Clicca il bottone Aggiungi scorciatoia."

#: src/components/shortcuts-settings.jsx:415
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Non sai cosa aggiungere?<0/>Prova con <1>Home / Seguiti e Notifiche</1> prima."

#: src/components/shortcuts-settings.jsx:443
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Max {SHORTCUTS_LIMIT} colonne"

#: src/components/shortcuts-settings.jsx:444
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Max {SHORTCUTS_LIMIT} scorciatoie"

#: src/components/shortcuts-settings.jsx:458
msgid "Import/export"
msgstr "Importa/esporta"

#: src/components/shortcuts-settings.jsx:468
msgid "Add column…"
msgstr "Aggiungi colonna…"

#: src/components/shortcuts-settings.jsx:469
msgid "Add shortcut…"
msgstr "Aggiungi scorciatoia…"

#: src/components/shortcuts-settings.jsx:516
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "Una lista specifica è opzionale. Per la modalità multi-colonna, è richiesta una lista, altrimenti la colonna non verrà mostrata."

#: src/components/shortcuts-settings.jsx:517
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Per la modalità multi-colonna, è richiesto un termine di ricerca, altrimenti la colonna non verrà mostrata."

#: src/components/shortcuts-settings.jsx:518
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Sono supportati hashtag multipli. Separati da uno spazio."

#: src/components/shortcuts-settings.jsx:587
msgid "Edit shortcut"
msgstr "Modifica scorciatoia"

#: src/components/shortcuts-settings.jsx:587
msgid "Add shortcut"
msgstr "Aggiungi scorciatoia"

#: src/components/shortcuts-settings.jsx:623
msgid "Timeline"
msgstr "Timeline"

#: src/components/shortcuts-settings.jsx:649
msgid "List"
msgstr "Lista"

#: src/components/shortcuts-settings.jsx:788
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Importa/Esporta <0>Scorciatoie</0>"

#: src/components/shortcuts-settings.jsx:798
msgid "Import"
msgstr "Importa"

#: src/components/shortcuts-settings.jsx:806
msgid "Paste shortcuts here"
msgstr "Incolla qui le scorciatoie"

#: src/components/shortcuts-settings.jsx:822
msgid "Downloading saved shortcuts from instance server…"
msgstr "Scaricando le scorciatoie salvate dal server dell'istanza…"

#: src/components/shortcuts-settings.jsx:851
msgid "Unable to download shortcuts"
msgstr "Impossibile scaricare scorciatoie"

#: src/components/shortcuts-settings.jsx:854
msgid "Download shortcuts from instance server"
msgstr "Scarica scorciatoie dal server dell'istanza"

#: src/components/shortcuts-settings.jsx:912
msgid "* Exists in current shortcuts"
msgstr "* Esiste nelle attuali scorciatoie"

#: src/components/shortcuts-settings.jsx:917
msgid "List may not work if it's from a different account."
msgstr "La lista potrebbe non funzionare se proviene da un account diverso."

#: src/components/shortcuts-settings.jsx:927
msgid "Invalid settings format"
msgstr "Formato impostazioni non valido"

#: src/components/shortcuts-settings.jsx:935
msgid "Append to current shortcuts?"
msgstr "Apporre alle scorciatoie attuali?"

#: src/components/shortcuts-settings.jsx:938
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Solo le scorciatoie che non esistono nelle scorciatoie attuali verranno apposte."

#: src/components/shortcuts-settings.jsx:960
msgid "No new shortcuts to import"
msgstr "Nessuna nuova scorciatoia da importare"

#: src/components/shortcuts-settings.jsx:975
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Scorciatoie importate. È stato superato il limite di {SHORTCUTS_LIMIT}, quindi il resto non verrà importato."

#: src/components/shortcuts-settings.jsx:976
#: src/components/shortcuts-settings.jsx:1000
msgid "Shortcuts imported"
msgstr "Scorciatoie importate"

#: src/components/shortcuts-settings.jsx:986
msgid "Import & append…"
msgstr "Importa e apponi…"

#: src/components/shortcuts-settings.jsx:994
msgid "Override current shortcuts?"
msgstr "Sovrascrivere le scorciatoie attuali?"

#: src/components/shortcuts-settings.jsx:995
msgid "Import shortcuts?"
msgstr "Importare scorciatoie?"

#: src/components/shortcuts-settings.jsx:1009
msgid "or override…"
msgstr "o sovrascrivi…"

#: src/components/shortcuts-settings.jsx:1009
msgid "Import…"
msgstr "Importa…"

#: src/components/shortcuts-settings.jsx:1018
msgid "Export"
msgstr "Esporta"

#: src/components/shortcuts-settings.jsx:1033
msgid "Shortcuts copied"
msgstr "Scorciatoie copiate"

#: src/components/shortcuts-settings.jsx:1036
msgid "Unable to copy shortcuts"
msgstr "Impossibile copiare scorciatoie"

#: src/components/shortcuts-settings.jsx:1050
msgid "Shortcut settings copied"
msgstr "Impostazioni scorciatoie copiate"

#: src/components/shortcuts-settings.jsx:1053
msgid "Unable to copy shortcut settings"
msgstr "Impossibile copiare impostazioni scorciatoie"

#: src/components/shortcuts-settings.jsx:1083
msgid "Share"
msgstr "Condividi"

#: src/components/shortcuts-settings.jsx:1122
msgid "Saving shortcuts to instance server…"
msgstr "Salvataggio scorciatoie nel server dell'istanza…"

#: src/components/shortcuts-settings.jsx:1129
msgid "Shortcuts saved"
msgstr "Scorciatoie salvate"

#: src/components/shortcuts-settings.jsx:1134
msgid "Unable to save shortcuts"
msgstr "Impossibile salvare scorciatoie"

#: src/components/shortcuts-settings.jsx:1137
msgid "Sync to instance server"
msgstr "Sincronizza con server istanza"

#: src/components/shortcuts-settings.jsx:1145
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, one {# carattere} other {# caratteri}}"

#: src/components/shortcuts-settings.jsx:1157
msgid "Raw Shortcuts JSON"
msgstr "JSON scorciatoie originale"

#: src/components/shortcuts-settings.jsx:1170
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Importa/esporta impostazioni da/su un server istanza (molto sperimentale)"

#: src/components/status.jsx:504
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>boostato</1>"

#: src/components/status.jsx:603
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Spiacenti, l'istanza a cui sei connesso non può interagire coi post di altre istanze."

#: src/components/status.jsx:756
msgid "Unliked @{0}'s post"
msgstr "Non ti piace più il post di @{0}"

#: src/components/status.jsx:757
msgid "Liked @{0}'s post"
msgstr "Hai messo Mi piace al post di @{0}"

#: src/components/status.jsx:796
msgid "Unbookmarked @{0}'s post"
msgstr "Post di @{0} rimosso dai segnalibri"

#: src/components/status.jsx:797
msgid "Bookmarked @{0}'s post"
msgstr "Post di @{0} aggiunto ai segnalibri"

#: src/components/status.jsx:903
#: src/components/status.jsx:965
#: src/components/status.jsx:2364
#: src/components/status.jsx:2396
msgid "Unboost"
msgstr "Annulla reblog"

#: src/components/status.jsx:919
#: src/components/status.jsx:2379
msgid "Quote"
msgstr "Cita"

#: src/components/status.jsx:927
#: src/components/status.jsx:2388
msgid "Some media have no descriptions."
msgstr "Alcuni contenuti non hanno una descrizione."

#: src/components/status.jsx:934
msgid "Old post (<0>{0}</0>)"
msgstr "Post vecchio (<0>{0}</0>)"

#: src/components/status.jsx:953
#: src/components/status.jsx:1408
msgid "Unboosted @{0}'s post"
msgstr "Reblog del post di @{0} annullato"

#: src/components/status.jsx:954
#: src/components/status.jsx:1409
msgid "Boosted @{0}'s post"
msgstr "Hai rebloggato il post di @{0}"

#: src/components/status.jsx:966
msgid "Boost…"
msgstr "Reblogga…"

#: src/components/status.jsx:978
#: src/components/status.jsx:1693
#: src/components/status.jsx:2409
msgid "Unlike"
msgstr "Non mi piace più"

#: src/components/status.jsx:979
#: src/components/status.jsx:1693
#: src/components/status.jsx:1694
#: src/components/status.jsx:2409
#: src/components/status.jsx:2410
msgid "Like"
msgstr "Mi piace"

#: src/components/status.jsx:988
#: src/components/status.jsx:2421
msgid "Unbookmark"
msgstr "Rimuovi dai segnalibri"

#: src/components/status.jsx:1096
msgid "View post by <0>@{0}</0>"
msgstr "Visualizza post di <0>@{0}</0>"

#: src/components/status.jsx:1117
msgid "Show Edit History"
msgstr "Mostra cronologia modifiche"

#: src/components/status.jsx:1120
msgid "Edited: {editedDateText}"
msgstr "Modificato: {editedDateText}"

#: src/components/status.jsx:1187
#: src/components/status.jsx:3188
msgid "Embed post"
msgstr "Incorpora post"

#: src/components/status.jsx:1201
msgid "Conversation unmuted"
msgstr "Conversazione riattivata"

#: src/components/status.jsx:1201
msgid "Conversation muted"
msgstr "Conversazione silenziata"

#: src/components/status.jsx:1207
msgid "Unable to unmute conversation"
msgstr "Impossibile riattivare la conversazione"

#: src/components/status.jsx:1208
msgid "Unable to mute conversation"
msgstr "Impossibile silenziare la conversazione"

#: src/components/status.jsx:1217
msgid "Unmute conversation"
msgstr "Riattiva conversazione"

#: src/components/status.jsx:1224
msgid "Mute conversation"
msgstr "Silenzia conversazione"

#: src/components/status.jsx:1240
msgid "Post unpinned from profile"
msgstr "Post tolto dal profilo"

#: src/components/status.jsx:1241
msgid "Post pinned to profile"
msgstr "Post fissato al profilo"

#: src/components/status.jsx:1246
msgid "Unable to unpin post"
msgstr "Impossibile togliere il post"

#: src/components/status.jsx:1246
msgid "Unable to pin post"
msgstr "Impossibile fissare post"

#: src/components/status.jsx:1255
msgid "Unpin from profile"
msgstr "Togli dal profilo"

#: src/components/status.jsx:1262
msgid "Pin to profile"
msgstr "Fissa sul profilo"

#: src/components/status.jsx:1291
msgid "Delete this post?"
msgstr "Eliminare questo post?"

#: src/components/status.jsx:1307
msgid "Post deleted"
msgstr "Post eliminato"

#: src/components/status.jsx:1310
msgid "Unable to delete post"
msgstr "Impossibile eliminare post"

#: src/components/status.jsx:1338
msgid "Report post…"
msgstr "Segnala post…"

#: src/components/status.jsx:1694
#: src/components/status.jsx:1730
#: src/components/status.jsx:2410
msgid "Liked"
msgstr "Ti piace"

#: src/components/status.jsx:1727
#: src/components/status.jsx:2397
msgid "Boosted"
msgstr "Rebloggato"

#: src/components/status.jsx:1737
#: src/components/status.jsx:2422
msgid "Bookmarked"
msgstr "Aggiunto ai segnalibri"

#: src/components/status.jsx:1741
msgid "Pinned"
msgstr "Fissato"

#: src/components/status.jsx:1786
#: src/components/status.jsx:2241
msgid "Deleted"
msgstr "Eliminato"

#: src/components/status.jsx:1827
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# risposta} other {# risposte}}"

#: src/components/status.jsx:1916
msgid "Thread{0}"
msgstr "Discussione{0}"

#: src/components/status.jsx:1992
#: src/components/status.jsx:2054
#: src/components/status.jsx:2139
msgid "Show less"
msgstr "Mostra meno"

#: src/components/status.jsx:1992
#: src/components/status.jsx:2054
msgid "Show content"
msgstr "Mostra contenuto"

#: src/components/status.jsx:2139
msgid "Show media"
msgstr "Mostra media"

#: src/components/status.jsx:2262
msgid "Edited"
msgstr "Modificato"

#: src/components/status.jsx:2339
msgid "Comments"
msgstr "Commenti"

#. More from [Author]
#: src/components/status.jsx:2648
msgid "More from <0/>"
msgstr "Più da <0/>"

#: src/components/status.jsx:2949
msgid "Edit History"
msgstr "Modifica Cronologia"

#: src/components/status.jsx:2953
msgid "Failed to load history"
msgstr "Impossibile caricare cronologia"

#: src/components/status.jsx:2958
msgid "Loading…"
msgstr "Carico…"

#: src/components/status.jsx:3193
msgid "HTML Code"
msgstr "Codice HTML"

#: src/components/status.jsx:3210
msgid "HTML code copied"
msgstr "Codice HTML copiato"

#: src/components/status.jsx:3213
msgid "Unable to copy HTML code"
msgstr "Impossibile copiare codice HTML"

#: src/components/status.jsx:3225
msgid "Media attachments:"
msgstr "Allegati multimediali:"

#: src/components/status.jsx:3247
msgid "Account Emojis:"
msgstr "Emoji dell'account:"

#: src/components/status.jsx:3278
#: src/components/status.jsx:3323
msgid "static URL"
msgstr "URL statico"

#: src/components/status.jsx:3292
msgid "Emojis:"
msgstr "Emoji:"

#: src/components/status.jsx:3337
msgid "Notes:"
msgstr "Note:"

#: src/components/status.jsx:3341
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "È statico, non stilizzato e senza script. Potresti dover applicare i tuoi stili e modificare di conseguenza."

#: src/components/status.jsx:3347
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "I sondaggi non sono interattivi, diventano una lista con i conteggi dei voti."

#: src/components/status.jsx:3352
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Gli allegati multimediali possono essere immagini, video, audio o qualsiasi tipo di file."

#: src/components/status.jsx:3358
msgid "Post could be edited or deleted later."
msgstr "Il post può essere modificato o eliminato dopo."

#: src/components/status.jsx:3364
msgid "Preview"
msgstr "Anteprima"

#: src/components/status.jsx:3373
msgid "Note: This preview is lightly styled."
msgstr "Nota: Questa anteprima è leggermente stilizzata."

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3615
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> ha rebloggato"

#: src/components/timeline.jsx:453
#: src/pages/settings.jsx:1130
msgid "New posts"
msgstr "Nuovi post"

#: src/components/timeline.jsx:554
#: src/pages/home.jsx:213
#: src/pages/notifications.jsx:824
#: src/pages/status.jsx:957
#: src/pages/status.jsx:1330
msgid "Try again"
msgstr "Riprova"

#: src/components/timeline.jsx:588
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr "{0, plural, one {# Reblog} other {# Reblog}}"

#: src/components/timeline.jsx:593
msgid "Pinned posts"
msgstr "Post fissati"

#: src/components/timeline.jsx:946
#: src/components/timeline.jsx:953
#: src/pages/catchup.jsx:1893
msgid "Thread"
msgstr "Discussione"

#: src/components/timeline.jsx:968
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Filtrati</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "Tradotto automaticamente da {sourceLangText}"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "Traduco…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Traduci da {sourceLangText} (auto-detected)"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "Traduci da {sourceLangText}"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "Auto ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "Traduzione fallita"

#: src/compose.jsx:32
msgid "Editing source status"
msgstr "Modifico stato originale"

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "In risposta a @{0}"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "Adesso puoi chiudere questa pagina."

#: src/compose.jsx:70
msgid "Close window"
msgstr "Chiudi finestra"

#: src/compose.jsx:86
msgid "Login required."
msgstr "Accesso richiesto."

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:270
msgid "Go home"
msgstr "Vai alla home"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "Post dell'account"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Risposte)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Reblog)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Media)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "Rimuovi filtri"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "Cancella"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "Mostrando post con risposte"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ Risposte"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "Mostrando post senza reblog"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- Reblog"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "Mostrando post con media"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "Mostrando post con #{0}"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "Mostrando post in {0}"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "Niente da vedere qui."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:449
msgid "Unable to load posts"
msgstr "Impossibile caricare i post"

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "Impossibile recuperare info account"

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "Passa all'istanza {0} dell'account "

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Passa alla mia istanza (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr "Mese"

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr "Attuale"

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "Default"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr "Passa a questo account"

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr "Passa in nuova scheda/finestra"

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr "Visualizza profilo…"

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "Imposta come predefinito"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr "Uscire da <0>@{0}</0>?"

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "Esci…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "Aggiungi un account esistente"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Nota: L'account <0>default</0> verrà sempre usato per il primo accesso. Gli account a cui passi rimarranno attivi durante la sessione."

#: src/pages/bookmarks.jsx:25
msgid "No bookmarks yet. Go bookmark something!"
msgstr "Ancora nessun segnalibro. Vai e aggiungi qualcosa!"

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "Impossibile caricare i segnalibri."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "ultima ora"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "ultime 2 ore"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "ultime 3 ore"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "ultime 4 ore"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "ultime 5 ore"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "ultime 6 ore"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "ultime 7 ore"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "ultime 8 ore"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "ultime 9 ore"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "ultime 10 ore"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "ultime 11 ore"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "ultime 12 ore"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "oltre 12 ore"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Tags seguiti"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Gruppi"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Mostrando {selectedFilterCategory, select, all {tutti i post} original {post originali} replies {risposte} boosts {reblog} followedTags {tag seguiti} groups {gruppi} filtered {post filtrati}}{sortBy, select, createdAt {{sortOrder, select, asc {dal più vecchio} desc {al più recente}}} reblogsCount {{sortOrder, select, asc {meno reblog} desc {più reblog}}} favouritesCount {{sortOrder, select, asc {meno like} desc {più like}}} repliesCount {{sortOrder, select, asc {meno risposte} desc {più risposte}}} density {{sortOrder, select, asc {meno densi} desc {più densi}}}} prima{groupBy, select, account {, raggruppato per autori} other {}}"

#: src/pages/catchup.jsx:882
#: src/pages/catchup.jsx:906
msgid "Catch-up <0>beta</0>"
msgstr "Recupera <0>beta</0>"

#: src/pages/catchup.jsx:896
#: src/pages/catchup.jsx:1585
msgid "Help"
msgstr "Aiuto"

#: src/pages/catchup.jsx:912
msgid "What is this?"
msgstr "Cos'è questo?"

#: src/pages/catchup.jsx:915
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Recupera è una timeline separata per gli account che segui, offre una visione panoramica con un'interfaccia semplice ispirata alle email per poter organizzare e filtrare i post."

#: src/pages/catchup.jsx:926
msgid "Preview of Catch-up UI"
msgstr "Anteprima IU di Recupera"

#: src/pages/catchup.jsx:935
msgid "Let's catch up"
msgstr "Recuperiamo"

#: src/pages/catchup.jsx:940
msgid "Let's catch up on the posts from your followings."
msgstr "Recuperiamo i post dai tuoi seguiti."

#: src/pages/catchup.jsx:944
msgid "Show me all posts from…"
msgstr "Mostrami tutti i post da…"

#: src/pages/catchup.jsx:967
msgid "until the max"
msgstr "fino al massimo"

#: src/pages/catchup.jsx:997
msgid "Catch up"
msgstr "Recupera"

#: src/pages/catchup.jsx:1003
msgid "Overlaps with your last catch-up"
msgstr "Si sovrappone con il tuo ultimo recupero"

#: src/pages/catchup.jsx:1015
msgid "Until the last catch-up ({0})"
msgstr "Fino all'ultimo recupero ({0})"

#: src/pages/catchup.jsx:1024
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Nota: la tua istanza potrebbe mostrare solamente un massimo di 800 post nella timeline della Home a prescindere dal lasso di tempo. Può essere di meno o di più."

#: src/pages/catchup.jsx:1034
msgid "Previously…"
msgstr "Precedentemente…"

#: src/pages/catchup.jsx:1052
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural,one {# post}other {# posts}}"

#: src/pages/catchup.jsx:1062
msgid "Remove this catch-up?"
msgstr "Rimuovere questo recupero?"

#: src/pages/catchup.jsx:1083
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Nota: Verranno salvati al massimo 3. Il resto verrà automaticamente rimosso."

#: src/pages/catchup.jsx:1098
msgid "Fetching posts…"
msgstr "Recupero post…"

#: src/pages/catchup.jsx:1101
msgid "This might take a while."
msgstr "Potrebbe volerci un po' di tempo."

#: src/pages/catchup.jsx:1136
msgid "Reset filters"
msgstr "Resetta filtri"

#: src/pages/catchup.jsx:1144
#: src/pages/catchup.jsx:1591
msgid "Top links"
msgstr "Top link"

#: src/pages/catchup.jsx:1261
msgid "Shared by {0}"
msgstr "Condiviso da {0}"

#: src/pages/catchup.jsx:1316
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:222
msgid "All"
msgstr "Tutto"

#: src/pages/catchup.jsx:1401
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural,one {# autore} other {# autori}}"

#: src/pages/catchup.jsx:1413
msgid "Sort"
msgstr "Ordina"

#: src/pages/catchup.jsx:1444
msgid "Date"
msgstr "Data"

#: src/pages/catchup.jsx:1448
msgid "Density"
msgstr "Densità"

#: src/pages/catchup.jsx:1486
msgid "Authors"
msgstr "Autori"

#: src/pages/catchup.jsx:1487
msgid "None"
msgstr "Nessuno"

#: src/pages/catchup.jsx:1503
msgid "Show all authors"
msgstr "Mostra tutti gli autori"

#: src/pages/catchup.jsx:1554
msgid "You don't have to read everything."
msgstr "Non devi leggere tutto."

#: src/pages/catchup.jsx:1555
msgid "That's all."
msgstr "È tutto."

#: src/pages/catchup.jsx:1563
msgid "Back to top"
msgstr "Torna su"

#: src/pages/catchup.jsx:1594
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Link condivisi da account che segui, ordinati per numero di condivisioni, reblog e Mi piace."

#: src/pages/catchup.jsx:1600
msgid "Sort: Density"
msgstr "Ordina: Densità"

#: src/pages/catchup.jsx:1603
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "I post sono ordinati in base alla loro densità o profondità informativa. I post più brevi sono più \"leggeri\" mentre i post più lunghi sono più \"pesanti\". I post con foto sono più \"pesanti\" dei post senza foto."

#: src/pages/catchup.jsx:1610
msgid "Group: Authors"
msgstr "Gruppo: Autori"

#: src/pages/catchup.jsx:1613
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "I post vengono raggruppati in base agli autori, ordinati dal numero di post per autore."

#: src/pages/catchup.jsx:1660
msgid "Next author"
msgstr "Prossimo autore"

#: src/pages/catchup.jsx:1668
msgid "Previous author"
msgstr "Autore precedente"

#: src/pages/catchup.jsx:1684
msgid "Scroll to top"
msgstr "Torna su"

#: src/pages/catchup.jsx:1875
msgid "Filtered: {0}"
msgstr "Filtrati: {0}"

#: src/pages/favourites.jsx:25
msgid "No likes yet. Go like something!"
msgstr "Ancora nessun mi piace. Metti mi piace a qualcosa!"

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "Impossibile caricare i Mi piace."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Casa e liste"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Timeline pubbliche"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Conversazioni"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Profili"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Mai"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Nuovo filtro"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# filtro} other {# filtri}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "Impossibile caricare filtri."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Ancora nessun filtro."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Aggiungi filtro"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Modifica filtro"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "Impossibile modificare filtro"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "Impossibile creare filtro"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Titolo"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Intera parola"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "Nessuna parola chiave. Aggiungine una."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Aggiungi parola chiave"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# parola chiave} other {# parole chiave}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Filtra da…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Non ancora implementato"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Status: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Cambia scadenza"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Scadenza"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr "I post filtrati saranno…"

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "contratti"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "nascosti"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Eliminare questo filtro?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "Impossibile eliminare filtro."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr "Scaduto"

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr "Scadendo <0/>"

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr "Senza scadenza"

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# hashtag} other {# hashtag}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "Impossibile caricare hashtag sguiti."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "Ancora nessun hashtag seguito."

#: src/pages/following.jsx:143
msgid "Nothing to see here."
msgstr "Niente da vedere qui."

#: src/pages/following.jsx:144
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "Impossibile caricare i post."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (solo media) su {instance}"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} su {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (solo contenuti multimediali)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "Nessuno ha ancora pubblicato nulla con questo hashtag."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "Impossibile caricare i post con questo hashtag"

#: src/pages/hashtag.jsx:208
msgid "Unfollow #{hashtag}?"
msgstr "Smettere di seguire #{hashtag}?"

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "Non segui più #{hashtag}"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "Ora segui #{hashtag}"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "Seguiti…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr "Non più in evidenza sul profilo"

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr "Impossibile rimuovere dai contenuti in evidenza sul profilo"

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr "In evidenza sul profilo"

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr "Metti in evidenza sul profilo"

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, one {}other {Max # hashtag}}"

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "Aggiungi hashtag"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "Rimuovi hashtag"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {Max # scorciatoie raggiunte. Impossibile aggiungere scorciatoia.} other {Max # scorciatoie raggiunte. Impossibile aggiungere scorciatoia.}}"

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr "Questa scorciatoia esiste già"

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr "Aggiunta scorciatoia hashtag"

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "Aggiungi a Scorciatoie"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:478
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Inserisci una nuova istanza es. \"mastodon.social\""

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:481
msgid "Invalid instance"
msgstr "Istanza non valida"

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:493
msgid "Go to another instance…"
msgstr "Vai in un'altra istanza…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:504
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Vai alla mia istanza (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:209
msgid "Unable to fetch notifications."
msgstr "Impossibile recuperare notifiche."

#: src/pages/home.jsx:229
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>Nuove</0> <1>richieste di seguire</1>"

#: src/pages/home.jsx:235
msgid "See all"
msgstr "Mostra tutto"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Risolvo…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "Impossibile risolvere URL"

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "Ancora niente."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "Gestisci membri"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr "Rimuovere <0>@{0}</0> dalla lista?"

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "Rimuovere…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# lista} other {# liste}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "Ancora nessuna lista."

#: src/pages/login.jsx:109
#: src/pages/login.jsx:122
msgid "Failed to register application"
msgstr "Registrazione applicazione fallita"

#: src/pages/login.jsx:208
msgid "instance domain"
msgstr "dominio d'istanza"

#: src/pages/login.jsx:232
msgid "e.g. “mastodon.social”"
msgstr "es. \"mastodon.social\""

#: src/pages/login.jsx:243
msgid "Failed to log in. Please try again or try another instance."
msgstr "Errore d'accesso. Per favore prova ancora o prova con un'altra istanza."

#: src/pages/login.jsx:255
msgid "Continue with {selectedInstanceText}"
msgstr "Continua con {selectedInstanceText}"

#: src/pages/login.jsx:256
msgid "Continue"
msgstr "Continua"

#: src/pages/login.jsx:264
msgid "Don't have an account? Create one!"
msgstr "Non hai un account? Creane uno!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "Menzioni private"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "Privato"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "Nessuno ti ha menzionato :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "Impossibile caricare menzioni."

#: src/pages/notifications.jsx:103
msgid "You don't follow"
msgstr "Non segui"

#: src/pages/notifications.jsx:104
msgid "Who don't follow you"
msgstr "Chi non ti segue"

#: src/pages/notifications.jsx:105
msgid "With a new account"
msgstr "Con un nuovo account"

#: src/pages/notifications.jsx:106
msgid "Who unsolicitedly private mention you"
msgstr "Ti menziona in privato dal nulla"

#: src/pages/notifications.jsx:107
msgid "Who are limited by server moderators"
msgstr "È limitato dai moderatori dei server"

#: src/pages/notifications.jsx:538
#: src/pages/notifications.jsx:872
msgid "Notifications settings"
msgstr "Impostazioni di notifica"

#: src/pages/notifications.jsx:556
msgid "New notifications"
msgstr "Nuove notifiche"

#: src/pages/notifications.jsx:567
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Annuncio} other {Annunci}}"

#: src/pages/notifications.jsx:614
#: src/pages/settings.jsx:1118
msgid "Follow requests"
msgstr "Richieste di seguiti"

#: src/pages/notifications.jsx:619
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# richiesta di seguire} other {# richieste di seguire}}"

#: src/pages/notifications.jsx:674
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Filtrate notifiche da # persona} other {Filtrate notifiche da # persone}}"

#: src/pages/notifications.jsx:740
msgid "Only mentions"
msgstr "Solo menzioni"

#: src/pages/notifications.jsx:744
msgid "Today"
msgstr "Oggi"

#: src/pages/notifications.jsx:749
msgid "You're all caught up."
msgstr "Non ci sono novità."

#: src/pages/notifications.jsx:772
msgid "Yesterday"
msgstr "Ieri"

#: src/pages/notifications.jsx:820
msgid "Unable to load notifications"
msgstr "Impossibile caricare notifiche"

#: src/pages/notifications.jsx:899
msgid "Notifications settings updated"
msgstr "Impostazioni di notifica aggiornate"

#: src/pages/notifications.jsx:907
msgid "Filter out notifications from people:"
msgstr "Blocca notifiche da chi:"

#: src/pages/notifications.jsx:921
msgid "Filter"
msgstr "Filtra"

#: src/pages/notifications.jsx:924
msgid "Ignore"
msgstr "Ignora"

#: src/pages/notifications.jsx:997
msgid "Updated <0>{0}</0>"
msgstr "Aggiornato <0>{0}</0>"

#: src/pages/notifications.jsx:1065
msgid "View notifications from <0>@{0}</0>"
msgstr "Visualizza notifiche da <0>@{0}</0>"

#: src/pages/notifications.jsx:1086
msgid "Notifications from <0>@{0}</0>"
msgstr "Notifiche da <0>@{0}</0>"

#: src/pages/notifications.jsx:1153
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Da ora in poi le notifiche da @{0} non saranno bloccate"

#: src/pages/notifications.jsx:1158
msgid "Unable to accept notification request"
msgstr "Impossibile accettare richiesta di notifica"

#: src/pages/notifications.jsx:1163
msgid "Allow"
msgstr "Consenti"

#: src/pages/notifications.jsx:1183
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Da ora in poi le notifiche da @{0} non apparrianno in Notifiche filtrate."

#: src/pages/notifications.jsx:1188
msgid "Unable to dismiss notification request"
msgstr "Impossibile ignorare richiesta di notifica"

#: src/pages/notifications.jsx:1193
msgid "Dismiss"
msgstr "Ignora"

#: src/pages/notifications.jsx:1208
msgid "Dismissed"
msgstr "Ignorato"

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "Timeline locale ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "Timeline federata ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "Timeline locale"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "Timeline federata"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr "Nessuno ha ancora pubblicato nulla."

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr "Passa a Federata"

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr "Passa a Locale"

#: src/pages/search.jsx:43
msgid "Search: {q} (Posts)"
msgstr "Cerca: {q} (Post)"

#: src/pages/search.jsx:46
msgid "Search: {q} (Accounts)"
msgstr "Cerca: {q} (Account)"

#: src/pages/search.jsx:49
msgid "Search: {q} (Hashtags)"
msgstr "Cerca: {q} (Hashtag)"

#: src/pages/search.jsx:52
msgid "Search: {q}"
msgstr "Cerca: {q}"

#: src/pages/search.jsx:232
#: src/pages/search.jsx:314
msgid "Hashtags"
msgstr "Hashtag"

#: src/pages/search.jsx:264
#: src/pages/search.jsx:318
#: src/pages/search.jsx:388
msgid "See more"
msgstr "Mostra altro"

#: src/pages/search.jsx:290
msgid "See more accounts"
msgstr "Mostra altri account"

#: src/pages/search.jsx:304
msgid "No accounts found."
msgstr "Nessun account trovato."

#: src/pages/search.jsx:360
msgid "See more hashtags"
msgstr "Mostra altri hashtag"

#: src/pages/search.jsx:374
msgid "No hashtags found."
msgstr "Nessun hashtag trovato."

#: src/pages/search.jsx:418
msgid "See more posts"
msgstr "Mostra altri post"

#: src/pages/search.jsx:432
msgid "No posts found."
msgstr "Nessun post trovato."

#: src/pages/search.jsx:476
msgid "Enter your search term or paste a URL above to get started."
msgstr "Inserisci il termine di ricerca o incolla un URL sopra per iniziare."

#: src/pages/settings.jsx:81
msgid "Settings"
msgstr "Impostazioni"

#: src/pages/settings.jsx:90
msgid "Appearance"
msgstr "Aspetto"

#: src/pages/settings.jsx:166
msgid "Light"
msgstr "Chiaro"

#: src/pages/settings.jsx:177
msgid "Dark"
msgstr "Scuro"

#: src/pages/settings.jsx:190
msgid "Auto"
msgstr "Automatico"

#: src/pages/settings.jsx:200
msgid "Text size"
msgstr "Dimensione testo"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:205
#: src/pages/settings.jsx:230
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:244
msgid "Display language"
msgstr "Lingua visualizzata"

#: src/pages/settings.jsx:253
msgid "Volunteer translations"
msgstr "Traduzioni volontarie"

#: src/pages/settings.jsx:264
msgid "Posting"
msgstr "Pubblicazione"

#: src/pages/settings.jsx:271
msgid "Default visibility"
msgstr "Visibilità di default"

#: src/pages/settings.jsx:272
#: src/pages/settings.jsx:318
msgid "Synced"
msgstr "Sincronizzato"

#: src/pages/settings.jsx:297
msgid "Failed to update posting privacy"
msgstr "Aggiornamento visibilità post fallito"

#: src/pages/settings.jsx:320
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Sincronizzato con le impostazioni del tuo server di istanza. <0>Visita la tua istanza ({instance}) per altre impostazioni.</0>"

#: src/pages/settings.jsx:335
msgid "Experiments"
msgstr "Esperimenti"

#: src/pages/settings.jsx:348
msgid "Auto refresh timeline posts"
msgstr "Aggiorna automaticamente i post della timeline"

#: src/pages/settings.jsx:360
msgid "Boosts carousel"
msgstr "Carosello reblog"

#: src/pages/settings.jsx:376
msgid "Post translation"
msgstr "Traduzione post"

#: src/pages/settings.jsx:387
msgid "Translate to"
msgstr "Traduci in"

#: src/pages/settings.jsx:398
msgid "System language ({systemTargetLanguageText})"
msgstr "Lingua di sistema ({systemTargetLanguageText})"

#: src/pages/settings.jsx:424
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, one {}=0 {Nascondi tasto \"Traduci\" per:} other {Nascondi tasto \"Traduci\" per (#):}}"

#: src/pages/settings.jsx:478
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "Nota: Questa funzione utilizza servizi di traduzione esterni, alimentata da <0>Lingva API</0> e <1>Lingva Translate</1>."

#: src/pages/settings.jsx:512
msgid "Auto inline translation"
msgstr "Traduzione automatica in linea"

#: src/pages/settings.jsx:516
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Mostra automaticamente la traduzione per i post nella timeline. Funziona solo per i post <0>corti</0> senza avvisi contenuti, media e sondaggi."

#: src/pages/settings.jsx:536
msgid "GIF Picker for composer"
msgstr "Selezionatore di GIF per compositore"

#: src/pages/settings.jsx:540
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Nota: Questa funzione utilizza un servizio di ricerca GIF esterno, alimentato da <0>GIPHY</0>. Classificazione T (adatto a tutte le età), i parametri traccianti sono eliminati, le informazioni di referer sono omesse dalle richieste, ma i termini di ricerca e le informazioni sull'indirizzo IP raggiungeranno comunque i loro server."

#: src/pages/settings.jsx:569
msgid "Image description generator"
msgstr "Generatore di descrizioni d'immagine"

#: src/pages/settings.jsx:574
msgid "Only for new images while composing new posts."
msgstr "Solo per le nuove immagini mentre si compongono nuovi post."

#: src/pages/settings.jsx:581
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Nota: Questa funzionalità usa un servizio IA esterno, alimentato da <0>img-alt-api</0>. Potrebbe non funzionare correttamente. Solo per immagini e in inglese."

#: src/pages/settings.jsx:607
msgid "Server-side grouped notifications"
msgstr "Notifiche raggruppate dal server"

#: src/pages/settings.jsx:611
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "Funzionalità in stato alfa. Potenziale miglioramento nel raggruppamento delle finestre ma con una logica base di raggruppamento."

#: src/pages/settings.jsx:632
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "Importazione/esportazione \"cloud\" per le impostazioni delle scorciatoie."

#: src/pages/settings.jsx:637
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Molto sperimentale.<0/>Conservato nelle note del tuo profilo. Le note (private) del profilo sono usate principalmente per gli altri profili e sono nascoste per il tuo profilo."

#: src/pages/settings.jsx:648
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Nota: Questa funzionalità usa l'API del server d'istanza attualmente in accesso."

#: src/pages/settings.jsx:665
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Modalità mantello <0>(<1>Testo</1> → <2>████</2>)</0>"

#: src/pages/settings.jsx:674
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Sostituisci testo con blocchi, utile per fare screenshot e per questioni di privacy."

#: src/pages/settings.jsx:699
msgid "About"
msgstr "Informazioni"

#: src/pages/settings.jsx:738
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>Sviluppato</0> da <1>@cheeaun</1>"

#: src/pages/settings.jsx:767
msgid "Sponsor"
msgstr "Sponsor"

#: src/pages/settings.jsx:775
msgid "Donate"
msgstr "Dona"

#: src/pages/settings.jsx:783
msgid "Privacy Policy"
msgstr "Politica sulla privacy"

#: src/pages/settings.jsx:790
msgid "<0>Site:</0> {0}"
msgstr "<0>Sito:</0> {0}"

#: src/pages/settings.jsx:797
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Versione:</0> <1/> {0}"

#: src/pages/settings.jsx:812
msgid "Version string copied"
msgstr "Stringa di versione copiata"

#: src/pages/settings.jsx:815
msgid "Unable to copy version string"
msgstr "Impossibile copiare la stringa della versione"

#: src/pages/settings.jsx:1015
#: src/pages/settings.jsx:1020
msgid "Failed to update subscription. Please try again."
msgstr "Impossibile aggiornare iscrizione. Si prega di riprovare."

#: src/pages/settings.jsx:1026
msgid "Failed to remove subscription. Please try again."
msgstr "Impossibile rimuovere l'iscrizione. Per favore riprova."

#: src/pages/settings.jsx:1033
msgid "Push Notifications (beta)"
msgstr "Notifiche Push (beta)"

#: src/pages/settings.jsx:1055
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "Le notifiche push sono bloccate. Si prega di abilitarle nelle impostazioni del tuo browser."

#: src/pages/settings.jsx:1064
msgid "Allow from <0>{0}</0>"
msgstr "Consenti da <0>{0}</0>"

#: src/pages/settings.jsx:1073
msgid "anyone"
msgstr "chiunque"

#: src/pages/settings.jsx:1077
msgid "people I follow"
msgstr "persone che seguo"

#: src/pages/settings.jsx:1081
msgid "followers"
msgstr "seguaci"

#: src/pages/settings.jsx:1114
msgid "Follows"
msgstr "Seguiti"

#: src/pages/settings.jsx:1122
msgid "Polls"
msgstr "Sondaggi"

#: src/pages/settings.jsx:1126
msgid "Post edits"
msgstr "Modifiche del post"

#: src/pages/settings.jsx:1147
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "Il permesso push non è stato concesso dopo il tuo ultimo login. Dovrai <0><1>effettuare l'accesso</1> di nuovo per concedere l'autorizzazione push</0>."

#: src/pages/settings.jsx:1163
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "NOTA: Le notifiche push funzionano per <0>un account</0>."

#. js-lingui-explicit-id
#: src/pages/status.jsx:567
#: src/pages/status.jsx:1100
msgid "post.title"
msgstr ""

#: src/pages/status.jsx:791
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "Non hai effettuato l'accesso. Le interazioni (risposte, reblog, etc) non sono abilitate."

#: src/pages/status.jsx:811
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Questo post è di un'altra istanza (<0>{instance}</0>). Le interazioni (risposte, reblog, etc) non sono abilitate."

#: src/pages/status.jsx:839
msgid "Error: {e}"
msgstr "Errore: {e}"

#: src/pages/status.jsx:846
msgid "Switch to my instance to enable interactions"
msgstr "Passa alla mia istanza per abilitare le interazioni"

#: src/pages/status.jsx:948
msgid "Unable to load replies."
msgstr "Impossibile caricare risposte."

#: src/pages/status.jsx:1060
msgid "Back"
msgstr "Indietro"

#: src/pages/status.jsx:1091
msgid "Go to main post"
msgstr "Vai al post principale"

#: src/pages/status.jsx:1114
msgid "{0} posts above ‒ Go to top"
msgstr "{0} post sopra - Torna in cima"

#: src/pages/status.jsx:1157
#: src/pages/status.jsx:1220
msgid "Switch to Side Peek view"
msgstr "Passa a vista laterale"

#: src/pages/status.jsx:1221
msgid "Switch to Full view"
msgstr "Passa a vista completa"

#: src/pages/status.jsx:1239
msgid "Show all sensitive content"
msgstr "Mostra tutto il contenuto sensibile"

#: src/pages/status.jsx:1244
msgid "Experimental"
msgstr "Sperimentale"

#: src/pages/status.jsx:1253
msgid "Unable to switch"
msgstr "Impossibile cambiare"

#: src/pages/status.jsx:1260
msgid "Switch to post's instance ({0})"
msgstr "Passa all'istanza del post ({0})"

#: src/pages/status.jsx:1263
msgid "Switch to post's instance"
msgstr "Passa all'istanza del post"

#: src/pages/status.jsx:1321
msgid "Unable to load post"
msgstr "Impossibile caricare post"

#: src/pages/status.jsx:1438
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural,one {# risposta}other {<0>{1}</0> risposte}}"

#: src/pages/status.jsx:1456
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural,one {# commento}other {<0>{0}</0> commenti}}"

#: src/pages/status.jsx:1478
msgid "View post with its replies"
msgstr "Visualizza il post con le sue risposte"

#: src/pages/trending.jsx:71
msgid "Trending ({instance})"
msgstr "In tendenza su ({instance})"

#: src/pages/trending.jsx:228
msgid "Trending News"
msgstr "Notizie di tendenza"

#. By [Author]
#: src/pages/trending.jsx:347
msgid "By {0}"
msgstr "Di {0}"

#: src/pages/trending.jsx:408
msgid "Back to showing trending posts"
msgstr "Ritorna a visualizzare i post di tendenza"

#: src/pages/trending.jsx:413
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "Mostra i post che citano <0>{0}</0>"

#: src/pages/trending.jsx:425
msgid "Trending posts"
msgstr "Post in tendenza"

#: src/pages/trending.jsx:448
msgid "No trending posts."
msgstr "Nessun post in tendenza."

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Un web client minimalista di Mastodon."

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Accedi con Mastodon"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr "Registrati"

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Collega il tuo account Mastodon o del Fediverso.<0/>Le tue credenziali non vengono salvate su questo server."

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>Costruito</0> da <1>@cheeaun</1>. <2>Infromativa sulla privacy</2>."

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr "Schermata del Carosello dei Reblog"

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr "Carosello dei Reblog"

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Separa visivamente i post originali e i post ri-condivisi (post boostati)."

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr "Screenshot della discussione a commenti annidati"

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr "Discussione a commenti annidati"

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Segui le conversazioni senza fatica. Risposte semi-comprimibili."

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr "Screenshot delle notifiche raggruppate"

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr "Notifiche raggruppate"

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "Le notifiche simili sono raggruppate e compresse per ridurre la confusione."

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr "Screenshot dell'interfaccia multi-colonna"

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr "Una o più colonne"

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Di default, una sola colonna per gli utenti zen. Modalità multi-colonna per gli utenti avanzati."

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Screenshot della timeline multi-hashtag con un modulo per aggiungere altri hashtag"

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr "Timeline multi-hashtag"

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Fino a 5 hastag combinati in una sola timeline."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Sembra che il tuo browser stia bloccando le finestre a comparsa."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Un post bozza è attualmente contratto. Pubblicato o scartalo prima di crearne un altro."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Un post è attualmente aperto. Pubblicato o scartalo prima di crearne un altro."

